export enum OrderStatus {
    declined = 'declined',
    pending = 'pending',
    started = 'started',
}

export enum ContactFields {
    EMAIL = 'N-email',
    FIRST_NAME = 'N-first_name',
    LAST_NAME = 'N-last_name',
}
